// extracted by mini-css-extract-plugin
export default {"thumb":"WaterDailyNorma_thumb__OCRXu","boldText":"WaterDailyNorma_boldText__Gakpf","normalText":"WaterDailyNorma_normalText__vpPSF"};